import { EventEmitter, Inject, Injectable } from '@angular/core';
import { CoreService } from '@app/core/services/core.service';
import { environment } from '@env/environment';
import { ACTIVE_THEME, THEMES, Theme } from './symbols';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  themeChange = new EventEmitter<Theme>();

  constructor(
    @Inject(THEMES) public themes: Theme[],
    @Inject(ACTIVE_THEME) public theme: string,
    private coreService: CoreService
  ) {
    if (this.coreService.isMrd) {
      this.setTheme('theme-mrd');
    } else {
      this.setTheme('theme-receita-digital');
    }
  }

  getTheme(name: string): Theme {
    const theme = this.themes.find(t => t.name === name);
    if (!theme) {
      throw new Error(`Theme not found: '${name}'`);
    }
    return theme;
  }

  getActiveTheme() {
    return this.getTheme(this.theme);
  }

  getProperty(propName: string) {
    return this.getActiveTheme().properties[propName];
  }

  setTheme(name: string) {
    this.theme = name;
    this.themeChange.emit(this.getActiveTheme());
  }

  registerTheme(theme: Theme) {
    this.themes.push(theme);
  }

  updateTheme(name: string, properties: { [key: string]: string }) {
    const theme = this.getTheme(name);
    theme.properties = {
      ...theme.properties,
      ...properties
    };

    if (name === this.theme) {
      this.themeChange.emit(theme);
    }
  }
}
